import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { HeaderAction, HeaderActionDelegate } from './actions/headerActions';
import { initialState, UiState } from './state';

type UiActions = HeaderAction;

const delegates: {
  [key: string]: ActionDelegate<any, UiState>;
} = {
  ...HeaderActionDelegate,
};

export default function reduce(
  state: UiState = initialState,
  action: UiActions
): UiState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
